import AppLayout from "../layouts/Layout";
import {Container, Typography} from "@mui/material";


const ConfidentialPage = () => {
    return (<AppLayout>
        <Container>
            <h1>Политика конфиденциальности</h1>
            <Typography>Станица в разработке</Typography>
        </Container>
    </AppLayout>);
}

export default ConfidentialPage;